
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.154 29.67c7.64 0 13.834-6.193 13.834-13.833 0-7.64-6.193-13.834-13.834-13.834-7.64 0-13.834 6.194-13.834 13.834S13.514 29.67 21.154 29.67z","stroke":"#000C1F","stroke-width":"2.4","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M39.088 2.518a13.835 13.835 0 113.754 27.153","stroke":"#3DAFB8","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2 39.62a23.416 23.416 0 0138.31-.002","stroke":"#000C1F","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M42.846 29.67A23.383 23.383 0 0162 39.619","stroke":"#3DAFB8","stroke-width":"2.4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    